//NOTE: Safari 9.1 does not support const in strict mode.
const x = 9;
var LandingAnimationPromise = () =>
  import ('../../landinganimation/src/landinganimation.js')
var LandingAnimationFallBackPromise = () =>
  import ('../../landinganimation/src/landinganimation.fallback.js')

var firefoxRegex = /Firefox\/([0-9]+)/.exec(window.navigator.userAgent);
var chromeRegex = /Chrome\/([0-9]+)/.exec(window.navigator.userAgent);
var safariRegex = /AppleWebKit\/([0-9]+)/.exec(window.navigator.userAgent)
var edgeRegex = /Edge\/([0-9]+)/.exec(window.navigator.userAgent)
//MS Edge actually pretends to be boatloads of browsers...
///Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299

if (edgeRegex) {
  LandingAnimationFallBackPromise();
} else if (chromeRegex && chromeRegex[1] >= 60) {
  LandingAnimationPromise();
} else if (firefoxRegex && firefoxRegex[1] >= 50) {
  LandingAnimationPromise();
} else if (safariRegex && safariRegex[1] >= 500) {
  LandingAnimationPromise();
} else {
  LandingAnimationFallBackPromise();
}

//LandingAnimationPromise

import $ from 'jquery';
import 'jquery-validation';
import 'waypoints/lib/jquery.waypoints.js';
import 'reset-css/reset.css';
import 'animate.css/animate.min.css';
import '../less/colors.less';
import ClassGenPlans from './ClassGenPlans.js'

var appMaster = {
  smoothScroll: function () {
    // Smooth Scrolling
    $('a[href*="#"]').click(function (event) {
      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {

        var target = $(this.hash);
        if (target.length == 0) {
          try {
            target = $('[name=' + this.hash.slice(1) + ']');
          } catch (e) {
            console.log("Tried to navigate to a non-existent hash:" + this.hash)
            return true;
          }
        }

        var offset = 0;
        if (target.data('scrollOffset'))
          offset = parseFloat(target.data('scrollOffset'))
        $('html,body').animate({
          scrollTop: target.offset().top + offset
        }, 1000);
        event.preventDefault();
      }
    });
  },

  animateScript: function () {
    /*TODO: Fix the waypoints system. A temporary fix is below. */
    $('.scrollpoint').addClass('animated fadeInDown').addClass('active');

    /*
    $('.scrollpoint.sp-effect1').waypoint(function () {
      $(this.element).toggleClass('active');
      $(this.element).toggleClass('animated fadeInLeft');
    }, {
      offset: '100%'
    });
    $('.scrollpoint.sp-effect2').waypoint(function () {
      $(this.element).toggleClass('active');
      $(this.element).toggleClass('animated fadeInRight');
    }, {
      offset: '100%'
    });
    $('.scrollpoint.sp-effect3').waypoint(function () {
      $(this.element).addClass('active');
      $(this.element).addClass('animated fadeInDown');
      console.log('hit',this.element.className)
    }, {
      offset: '100%'
    });
    $('.scrollpoint.sp-effect4').waypoint(function () {
      $(this.element).toggleClass('active');
      $(this.element).toggleClass('animated fadeIn');
    }, {
      offset: '100%'
    });
    $('.scrollpoint.sp-effect5').waypoint(function () {
      $(this.element).toggleClass('active');
      $(this.element).toggleClass('animated fadeInUp');
    }, {
      offset: '100%'
    });*/
  },

  scrollMenu: function () {
    var num = 50; //number of pixels before modifying styles
    if ($(window).scrollTop() > num) {
      $('nav').addClass('scrolled');
    }
    $(window).bind('scroll', function () {
      if ($(window).scrollTop() > num) {
        $('nav').addClass('scrolled');

      } else {
        $('nav').removeClass('scrolled');
      }
    });

    $('ul.navbar-nav li a').bind('click', function () {
      if ($(this).closest('.navbar-collapse').hasClass('in')) {
        $(this).closest('.navbar-collapse').removeClass('in');
      }
    });

  },

  signUpForm: function () {
    var validator = $("#signUpForm").validate({
      rules: {
        password: {
          minlength: 5
        },
        /*password_confirm: {
          equalTo: "#password"
        }*/
      },
      messages: {
        password: "The password needs to be at least 8 characters, to ward off password gremlins.",
        //password_confirm: "These passwords aren't a perfect match. How sad for them.",
        firstName: {
          minlength: "Surely your name can't be that short.",
          required: "If you have forgotten your name, consider asking a friend to remind you."
        },
        lastName: "Not sure? Perhaps ask a family member what your name is.",
        email: "If you don't enter your email address, how will you recover your password? Hmm.",
        privacyCheck: 'I know that legal stuff is horribly boring, but you do need to accept these conditions to use ClassGen.'
      }
    });

    $("#signUpForm").submit(function (e) {
      var isvalid = $("#signUpForm").valid();
      if (!isvalid) {
        validator.showErrors();
        e.preventDefault();
        return;
      }

      var plan = $('[name=plan]').val();
      if (plan == 'PRO') {
        e.preventDefault();
        $('body').addClass('noscroll');
        $('.signUpContainer').addClass('loading');
        stripeSubmitHandler(e);
      } else if (plan == 'FREE') {
        e.preventDefault();
        $('body').addClass('noscroll');
        $('.signUpContainer').addClass('loading');
        postSignupForm();
      }
    });

    $('.not-sure-button').click(function (e) {
      $('.more-reasons:not(.visible)').first().addClass('visible').slideDown();

      if ($('.more-reasons:not(.visible)').length == 0)
        $('.not-sure-button').slideUp();
    })

    $('#getApp .planContainer .panel').click(function (e) {
      if ($(e.target).closest('.not-sure-button').length !== 0)
        return true;

      $('#getApp .panel').removeClass('active');
      $('#getApp .panel').removeClass('active').addClass('inactive');
      $(this).removeClass('inactive')
        .addClass('active');
      var plan = $(this).find('.signUpButton').data('plan');
      $('[name=plan]').val(plan)


      $('html,body').animate({
        scrollTop: $('#signUpAnchor').offset().top - 100
      }, 1000);

      switch (plan) {
        case 'INSTITUTION':
          $('#contact [name=message]').val("Hi Tom, I'm interested in the institution package for ClassGen.")
          $('.signUpContainer').slideUp();
          break;
        case 'PRO':
          $('#card-element').show();
          $('.upgrade-page-security').show();
          $('.signUpContainer').slideDown();
          break;
        case 'FREE':
          $('#card-element').hide();
          $('.upgrade-page-security').hide();
          $('.signUpContainer').slideDown();
          break;
      }
    });

    function postSignupForm() {
      var form = $('#signUpForm');
      var formDataObject = {}
      var formDataArray = form.serializeArray();
      formDataArray.forEach(function (input) {
        formDataObject[input.name] = input.value;
      });
      $.post('/signup', formDataArray)
        .done(function (response) {
          if (formDataObject.plan == 'PRO') {
            window.ga('send', 'event', {
              eventCategory: 'signup',
              eventAction: 'signup_pro',
              eventLabel: 'signup_pro_new',
              transport: 'beacon'
            });
          } else {
            window.ga('send', 'event', {
              eventCategory: 'signup',
              eventAction: 'signup_free',
              transport: 'beacon'
            });
          }

          window.location = '/app';
          $('body').removeClass('noscroll');
          $('signUpContainer ').removeClass('loading');
        })
        .fail(function (response) {
          var errorCode = '';
          if (response && response.responseJSON.error && response.responseJSON.error)
            errorCode = response.responseJSON.error;

          var errorText = 'Hmm, it looks like something went wrong. Please <a href="/contact">contact me</a> so that I can fix the problem.';
          switch (errorCode) {
            case 'CARD_ERROR':
              errorText = response.responseJSON.stripeError;
              break;
            case 'ACCOUNT_EXISTS':
              errorText = 'There is already an account with that email address... but a different password! Maybe you <a href="/login#forgot">forgot&nbsp;your&nbsp;password</a>?'
              break;
            default:
              console.error('postSignupForm', response)
              break;
          }
          $('#card-errors').show().html(errorText);
        }).always(function () {
          $('#signUpForm [name=stripeToken]').remove();
          $('body').removeClass('noscroll');
          $('.signUpContainer').removeClass('loading');
        })
    }

    var stripe = null;
    var card = null;

    $.get('/stripe_public_key').done(function (response) {
      var stripe_public_key = response.key;
      if (!stripe_public_key) {
        Raven.captureMessage('Could not get stripe public key :(', { extra: response });
      }
      stripe = Stripe(stripe_public_key);
      var elements = stripe.elements();

      var style = {
        base: {
          fontSize: '16px',
          color: "#32325d",
        }
      };

      // Create an instance of the card Element.
      card = elements.create('card', { style: style });

      // Add an instance of the card Element into the `card-element` <div>.
      card.mount('#card-element');
    }).fail(function (response) {
      console.error(response);
    })

    var featureElements = ClassGenPlans[0].features.map(feature => $('<li>').html(feature))
    $('.free-reasons').append(featureElements);

    var featureElements = ClassGenPlans[1].features.map(feature => $('<li>').html(feature))
    $('.pro-reasons').append(featureElements);
    $('.pro-reasons li').slice(5).addClass('more-reasons');

    var featureElements = ClassGenPlans[2].features.map(feature => $('<li>').html(feature))
    $('.institution-reasons').append(featureElements);


    function stripeSubmitHandler(event) {

      stripe.createToken(card).then(function (result) {
        if (result.error) {
          // Inform the customer that there was an error.
          $('#card-errors').show().text(result.error.message);
          $('body').removeClass('noscroll');
          $('.signUpContainer').removeClass('loading');
        } else {
          // Send the token to your server.
          stripeTokenHandler(result.token);
        }
      });
    };

    function stripeTokenHandler(token) {

      // Insert the token ID into the form so it gets submitted to the server
      var form = $('#signUpForm');
      var hiddenInput = document.createElement('input');
      hiddenInput.setAttribute('type', 'hidden');
      hiddenInput.setAttribute('name', 'stripeToken');
      hiddenInput.setAttribute('value', token.id);
      form[0].appendChild(hiddenInput);

      postSignupForm();
    }
  }

};

$(document).ready(function () {

  appMaster.smoothScroll();

  appMaster.animateScript();

  appMaster.scrollMenu();

  appMaster.signUpForm();

  $('.navbar-toggle').click(function () {
    $('.navbar-collapse').toggleClass('collapse');
  })

  $(document).click(function (event) {
    if ($(event.target).closest('.navbar-toggle').length == 0) {
      $('.navbar-collapse').addClass('collapse');
    }
  })

  //$('#preloader').removeClass('visible');
});
